import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBusinessProductsAPI,
  getInventoryChildVariantProductsAPI,
  getInventoryOndcFilterAPI,
  getInventoryProductsByStatusAPI,
  getInventorySingleOndcFilterAPI,
  getInventorySingleProductsByStatusAPI,
  getInventoryVariantProductsAPI,
  getVariantSingleCountAPI,
} from "../../service/api_calls/inventory/InventoryApi";
import {
  filterNotSellingProducts,
  filterPriceUpdateProducts,
  prepareLowAndOOSProducts,
  updatePriceInputDetails,
  updateQuickPriceInputDetails,
} from "./inventoryHelper";
import { getDashboardInventorySummaryApi } from "../../service/api_calls/BusinessDashboard/BusinessDashboardApi";
import { getONDCCategoriesAPI } from "../../service/api_calls/BusinessPreview/BusinessPreviewAPI";
import {
  ALL_STOCK_COLUMN_HEADER_CHILD_VARIANT,
  LS_COLUMN_HEADER_CHILD_VARIANT,
  OOS_COLUMN_HEADER_CHILD_VARIANT,
  PU_COLUMN_HEADER_CHILD_VARIANT,
} from "../../utils/data";

const initialState = {
  lowStockProducts: [],
  lowStockPageNo: 1,
  lowStockProductsLoader: false,

  lowStockVariantProducts: [],
  lowStockVariantPageNo: 1,
  lowStockVariantProductsLoader: false,

  lowStockChildVariantProducts: [],
  lowStockChildVariantProductHeader: [],
  lowStockChildVariantProductsLoader: false,

  outOfStockProducts: [],
  outOfStockPageNo: 1,
  outOfStockProductsLoader: false,

  outOfStockVariantProducts: [],
  outOfStockVariantPageNo: 1,
  outOfStockVariantProductsLoader: false,

  outOfStockChildVariantProducts: [],
  outOfStockChildVariantProductHeader: [],
  outOfStockChildVariantProductsLoader: false,

  priceUpdateProducts: [],
  priceUpdatePageNo: 1,
  priceUpdateProductsLoader: false,

  priceUpdateVariantProducts: [],
  priceUpdateVariantPageNo: 1,
  priceUpdateVariantProductsLoader: false,

  priceUpdateChildVariantProducts: [],
  priceUpdateChildVariantProductHeader: [],
  priceUpdateChildVariantProductsLoader: false,

  allStockUpdateProducts: [],
  allStockUpdatePageNo: 1,
  allStockUpdateProductsLoader: false,

  allStockUpdateVariantProducts: [],
  allStockUpdateVariantPageNo: 1,
  allStockUpdateVariantProductsLoader: false,

  allStockUpdateChildVariantProducts: [],
  allStockChildVariantProductHeader: [],
  allStockChildVariantProductMobileHeader: [],
  allStockUpdateChildVariantProductsLoader: false,

  notSellingUpdateProducts: [],
  notSellingUpdatePageNo: 1,
  notSellingUpdateProductsLoader: false,

  notSellingVariantProducts: [],
  notSellingVariantPageNo: 1,
  notSellingVariantProductsLoader: false,

  notSellingChildVariantProducts: [],
  notSellingChildVariantProductHeader: [],
  notSellingChildVariantProductMobileHeader: [],
  notSellingChildVariantProductsLoader: false,

  inventorySummary: null,
  summaryLoader: false,

  inventorySearchResult: null,
  searchLoader: false,

  ondcDropdownData: [],
  categoryLoader: false,

  variantSingleInventoryCount: null,
  variantSingleInventoryCountLoader: false,

  isBulkPriceUpdateSuccess: null,
  filterCount: 0,
  filterLoader: false,
};

// Get Low Stock Products
export const getAllLowStockProducts = createAsyncThunk(
  "getAllLowStockProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);
// Get Low Stock Variant Products
export const getAllLowStockVariantProducts = createAsyncThunk(
  "getAllLowStockVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get Price Update Child Products
export const getLowStockChildVariantProducts = createAsyncThunk(
  "getLowStockChildVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryChildVariantProductsAPI(param);
    return res;
  }
);

// Refresh Low Stock Products
export const refreshLowStockProducts = createAsyncThunk(
  "refreshLowStockProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);
// Refresh Low Stock Products
export const refreshLowStockVariantProducts = createAsyncThunk(
  "refreshLowStockVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get Out Of Stock Products
export const getAllOutOfStockProducts = createAsyncThunk(
  "getAllOutOfStockProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);
// Get Out Of Stock Products
export const getAllOutOfStockVariantProducts = createAsyncThunk(
  "getAllOutOfStockVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get Price Update Child Products
export const getOutOfStockChildVariantProducts = createAsyncThunk(
  "getOutOfStockChildVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryChildVariantProductsAPI(param);
    return res;
  }
);

// Refresh Out Of Stock Products
export const refreshOutOfStockProducts = createAsyncThunk(
  "refreshOutOfStockProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);
// Refresh Out Of Stock Products
export const refreshOutOfStockVariantProducts = createAsyncThunk(
  "refreshOutOfStockVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get Price Update Products
export const getPriceUpdateProducts = createAsyncThunk(
  "getPriceUpdateProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);
// Get Price Update Main Variant Products
export const getPriceUpdateVariantProducts = createAsyncThunk(
  "getPriceUpdateVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get Price Update Child Products
export const getPriceUpdateChildVariantProducts = createAsyncThunk(
  "getPriceUpdateChildVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryChildVariantProductsAPI(param);
    return res;
  }
);

// Refresh Price Update Products
export const refreshPriceUpdateProducts = createAsyncThunk(
  "refreshPriceUpdateProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);
// Refresh Price Update Products
export const refreshPriceUpdateChildProducts = createAsyncThunk(
  "refreshPriceUpdateChildProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get All stock Update Products
export const getAllStockUpdateProducts = createAsyncThunk(
  "getAllStockUpdateProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);

// Get All stock Update Products
export const getAllStockUpdateVariantProducts = createAsyncThunk(
  "getAllStockUpdateVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get All stock Update Products
export const getAllStockUpdateChildVariantProducts = createAsyncThunk(
  "getAllStockUpdateChildVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryChildVariantProductsAPI(param);
    return res;
  }
);

// Refresh All stock Update Products
export const refreshAllStockUpdateProducts = createAsyncThunk(
  "refreshAllStockUpdateProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);
// Refresh All stock Update Products
export const refreshAllStockUpdateVariantProducts = createAsyncThunk(
  "refreshAllStockUpdateVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get Not Selling Update Products
export const getNotSellingUpdateProducts = createAsyncThunk(
  "getNotSellingUpdateProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);
// Get Not Selling Update Products
export const getNotSellingVariantProducts = createAsyncThunk(
  "getNotSellingVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get Not selling child variants Products
export const getNotSellingChildVariantProducts = createAsyncThunk(
  "getNotSellingChildVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryChildVariantProductsAPI(param);
    return res;
  }
);

// Refresh Not Selling Update Products
export const refreshNotSellingUpdateProducts = createAsyncThunk(
  "refreshNotSellingUpdateProducts",
  async (param, thunkAPI) => {
    const res = await getInventorySingleProductsByStatusAPI(param);
    return res;
  }
);

// Refresh Not Selling Varint Update Products
export const refreshNotSellingVariantProducts = createAsyncThunk(
  "refreshNotSellingVariantProducts",
  async (param, thunkAPI) => {
    const res = await getInventoryVariantProductsAPI(param);
    return res;
  }
);

// Get Inventory Summary Counts
export const getInventorySummaryCounts = createAsyncThunk(
  "getInventorySummaryCounts",
  async (param, thunkAPI) => {
    const res = await getDashboardInventorySummaryApi(param);
    return res;
  }
);

// Search Inventory Products
export const searchInventoryProducts = createAsyncThunk(
  "searchInventoryProducts",
  async (param, thunkAPI) => {
    let res = null;
    const apiCall =
      param?.type === "withoutvariant"
        ? getInventorySingleProductsByStatusAPI(param)
        : getInventoryVariantProductsAPI(param);
    // const res = await getInventoryProductsByStatusAPI(param);

    res = await apiCall;

    return {
      result: res?.details || [],
      status: param?.tabStatus || "",
      type: param?.type,
    };
  }
);

// Get Category List Data
export const getCategoryDropdownListData = createAsyncThunk(
  "getCategoryDropdownListData",
  async (businessId, thunkAPI) => {
    const ondcCategoryData = await getONDCCategoriesAPI(businessId);

    return {
      ondcCategoryData,
    };
  }
);

// ONDC Filter
export const filterInventoryOndcProducts = createAsyncThunk(
  "filterInventoryOndcProducts",
  async (param, thunkAPI) => {
    let res = null;
    const apiCall =
      param?.type === "withoutvariant"
        ? getInventorySingleOndcFilterAPI(param)
        : getInventoryOndcFilterAPI(param);

    res = await apiCall;
    return {
      result:
        param?.type === "withoutvariant"
          ? res?.details?.data
            ? [...res?.details?.data]
            : []
          : [...res?.details],
      status: param?.tabStatus || "",
      pageNo: param?.pageNo || 1,
      type: param?.type,
      filterCount:
        param?.type === "withoutvariant" ? res?.details?.totalCount : 0,
    };
  }
);

export const getVariantSingleCount = createAsyncThunk(
  "getVariantSingleCount",
  async (param, thunkAPI) => {
    const res = await getVariantSingleCountAPI(param);
    return res;
  }
);

export const businessInventory = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    clearInventoryInfo: (state, action) => {
      state.lowStockProducts = [];
      state.lowStockPageNo = 1;
      state.lowStockProductsLoader = false;

      state.outOfStockProducts = [];
      state.outOfStockPageNo = 1;
      state.outOfStockProductsLoader = false;

      state.priceUpdateProducts = [];
      state.priceUpdatePageNo = 1;
      state.priceUpdateProductsLoader = false;

      state.allStockUpdateProducts = [];
      state.allStockUpdatePageNo = 1;
      state.allStockUpdateProductsLoader = false;

      state.allStockUpdateVariantProducts = [];
      state.allStockUpdateVariantPageNo = 1;
      state.allStockUpdateVariantProductsLoader = false;

      state.notSellingUpdateProducts = [];
      state.notSellingUpdatePageNo = 1;
      state.notSellingUpdateProductsLoader = false;

      state.isBulkPriceUpdateSuccess = null;
      state.filterCount = 0;
    },

    clearAllInventoryInfo: (state, action) => {
      state.lowStockProducts = [];
      state.lowStockPageNo = 1;
      state.lowStockProductsLoader = false;

      state.outOfStockProducts = [];
      state.outOfStockPageNo = 1;
      state.outOfStockProductsLoader = false;

      state.priceUpdateProducts = [];
      state.priceUpdatePageNo = 1;
      state.priceUpdateProductsLoader = false;

      state.allStockUpdateProducts = [];
      state.allStockUpdatePageNo = 1;
      state.allStockUpdateProductsLoader = false;

      state.notSellingUpdateProducts = [];
      state.notSellingUpdatePageNo = 1;
      state.notSellingUpdateProductsLoader = false;

      state.inventorySummary = null;
      state.inventorySearchResult = null;
      state.variantSingleInventoryCount = null;

      state.ondcDropdownData = [];
      state.filterCount = 0;
    },

    // Handle Price Update On change
    handlePriceUpdateChange: (state, action) => {
      const { priceUpdateProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        priceUpdateProducts,
        value,
        index
      );

      state.priceUpdateProducts = [...updatedProductsList];
    },

    // Apply Quick Price Update Data
    handleQuickPriceUpdate: (state, action) => {
      const { priceUpdateProducts, quickUpdateData } = action.payload;

      const updatedProductsList = updateQuickPriceInputDetails(
        priceUpdateProducts,
        quickUpdateData
      );

      state.priceUpdateProducts = [...updatedProductsList];
      state.isBulkPriceUpdateSuccess = updatedProductsList?.map(
        (item) =>
          `${JSON.stringify(item?.gstInfo)}, ${item?.productSalePrice}, ${
            item?.commerceEndDate
          }`
      );
    },

    // Update Price Info List
    updatePriceInfoList: (state, action) => {
      const { priceUpdateProducts } = action.payload;
      state.priceUpdateProducts = [...priceUpdateProducts];
    },
    // Update Price Info Child List
    updatePriceInfoVariantList: (state, action) => {
      const { priceUpdateProducts } = action.payload;
      state.priceUpdateChildVariantProducts = [...priceUpdateProducts];
    },

    // Handle All Stock Update On change
    handleAllStockUpdateChange: (state, action) => {
      const { priceUpdateProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        priceUpdateProducts,
        value,
        index
      );

      console.log("handleAllStockUpdateChange___:", updatedProductsList);

      state.allStockUpdateProducts = [...updatedProductsList];
    },

    // Handle All Stock Child Update On change
    handleAllStockChildUpdateChange: (state, action) => {
      const { priceUpdateProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        priceUpdateProducts,
        value,
        index
      );

      console.log("handleAllStockChildUpdateChange___:", updatedProductsList);

      state.allStockUpdateChildVariantProducts = [...updatedProductsList];
    },

    // Handle All Stock Child Update On change
    handlePriceUpdateChildProductChange: (state, action) => {
      const { priceUpdateProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        priceUpdateProducts,
        value,
        index
      );

      console.log("handlePriceUpdateChildProductChange:", updatedProductsList);

      state.priceUpdateChildVariantProducts = [...updatedProductsList];
    },

    // Apply Quick All Stock Update Data
    handleQuickAllStockUpdate: (state, action) => {
      const { allStockUpdateProducts, quickUpdateData } = action.payload;

      const updatedProductsList = updateQuickPriceInputDetails(
        allStockUpdateProducts,
        quickUpdateData
      );

      state.allStockUpdateProducts = [...updatedProductsList];
    },

    // Update All Stock Info List
    updateAllStockInfoList: (state, action) => {
      const { allStockUpdateProducts } = action.payload;
      state.allStockUpdateProducts = [...allStockUpdateProducts];
    },

    // Update Price Info Child List
    updateAllStockInfoVariantList: (state, action) => {
      const { allStockUpdateProducts } = action.payload;
      state.allStockUpdateChildVariantProducts = [...allStockUpdateProducts];
    },

    // Handle Not Selling Update On change
    handleNotSellingUpdateChange: (state, action) => {
      const { priceUpdateProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        priceUpdateProducts,
        value,
        index
      );

      console.log("handleNotSellingUpdateChange___:", updatedProductsList);

      state.notSellingUpdateProducts = [...updatedProductsList];
    },

    // Apply Quick Not Selling Update Data
    handleQuickNotSellingUpdate: (state, action) => {
      const { notSellingUpdateProducts, quickUpdateData } = action.payload;

      const updatedProductsList = updateQuickPriceInputDetails(
        notSellingUpdateProducts,
        quickUpdateData
      );

      state.notSellingUpdateProducts = [...updatedProductsList];
    },

    // Update Not Selling Info List
    updateNotSellingInfoList: (state, action) => {
      const { notSellingUpdateProducts } = action.payload;
      state.notSellingUpdateProducts = [...notSellingUpdateProducts];
    },

    // Update Price Info Child List
    updateNotSellingInfoVariantList: (state, action) => {
      const { notSellingUpdateProducts } = action.payload;
      state.notSellingChildVariantProducts = [...notSellingUpdateProducts];
    },

    // Handle Not selling Child Update On change
    handleNotSellingChildUpdateChange: (state, action) => {
      const { priceUpdateProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        priceUpdateProducts,
        value,
        index
      );

      console.log("handleNotSellingChildUpdateChange___:", updatedProductsList);

      state.notSellingChildVariantProducts = [...updatedProductsList];
    },

    // Handle Low stock Update On change
    handleLowStockUpdateChange: (state, action) => {
      const { lowStockProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        lowStockProducts,
        value,
        index
      );

      console.log("handleLowStockUpdateChange___:", updatedProductsList);

      state.lowStockProducts = [...updatedProductsList];
    },
    // Handle Low stock Update On change
    handleLowStockVariantUpdateChange: (state, action) => {
      const { lowStockProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        lowStockProducts,
        value,
        index
      );

      console.log("handleLowStockUpdateChange___:", updatedProductsList);

      state.lowStockChildVariantProducts = [...updatedProductsList];
    },

    // Update Low Stock Info List
    updateLowStockInfoList: (state, action) => {
      const { lowStockProducts } = action.payload;
      state.lowStockProducts = [...lowStockProducts];
    },
    // Update Low Stock Info List
    updateLowStockInfoVariantList: (state, action) => {
      const { lowStockProducts } = action.payload;
      state.lowStockChildVariantProducts = [...lowStockProducts];
    },

    // Handle Out Of Stock Update On change
    handleOutOfStockUpdateChange: (state, action) => {
      const { outOfStockProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        outOfStockProducts,
        value,
        index
      );

      console.log("handleOutOfStockUpdateChange___:", updatedProductsList);

      state.outOfStockProducts = [...updatedProductsList];
    },

    // Update Out Of Stock Info List
    updateOutOfStockInfoList: (state, action) => {
      const { outOfStockProducts } = action.payload;
      state.outOfStockProducts = [...outOfStockProducts];
    },

    // Handle Out Of Stock Variant Update On change
    handleOutOfStockVariantUpdateChange: (state, action) => {
      const { outOfStockProducts, value, index } = action.payload;

      const updatedProductsList = updatePriceInputDetails(
        outOfStockProducts,
        value,
        index
      );

      console.log("handleOutOfStockUpdateChange___:", updatedProductsList);

      state.outOfStockChildVariantProducts = [...updatedProductsList];
    },

    // Update Out Of Stock Variant Info List
    updateOutOfStockVariantInfoList: (state, action) => {
      const { outOfStockProducts } = action.payload;
      state.outOfStockChildVariantProducts = [...outOfStockProducts];
    },

    // Select All Rows
    selectAllInventoryProducts: (state, action) => {
      const { tabStatus, productList, selectType } = action.payload;

      const productArr = [...productList];
      const newArray = [];

      productArr.forEach((item) => {
        newArray.push({
          ...item,
          itemChange: selectType,
        });
      });

      console.log("productArr___tabStatus", tabStatus);
      console.log("productArr___", newArray);

      if (tabStatus === "out_of_stock") {
        state.outOfStockProducts = [...newArray];
      } else if (tabStatus === "low_stock") {
        state.lowStockProducts = [...newArray];
      } else if (tabStatus === "all_stock") {
        state.allStockUpdateProducts = [...newArray];
      } else if (tabStatus === "price_update") {
        state.priceUpdateProducts = [...newArray];
      } else if (tabStatus === "not_selling") {
        state.notSellingUpdateProducts = [...newArray];
      }
    },

    updateInventorySummary: (state, action) => {
      console.log("HTIIIIII____updateInventorySummary:", action);
      state.inventorySummary = action?.payload?.variantAllCount || null;
    },

    clearFilterCount: (state, action) => {
      state.filterCount = 0;
    },
  },

  extraReducers: {
    //fetch Low Stock Update Products
    [getAllLowStockProducts.pending]: (state) => {
      state.lowStockProductsLoader = true;
    },
    [getAllLowStockProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = prepareLowAndOOSProducts(productsData);

      // if (productsData.length > 0) {
      state.lowStockProducts = [...state.lowStockProducts, ...filteredList];
      // }

      state.lowStockPageNo = state.lowStockPageNo + 1;
      state.lowStockProductsLoader = false;
    },
    [getAllLowStockProducts.rejected]: (state) => {
      state.lowStockProductsLoader = false;
    },
    //fetch Low Stock Variant Products
    [getAllLowStockVariantProducts.pending]: (state) => {
      state.lowStockVariantProductsLoader = true;
    },
    [getAllLowStockVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];
      state.lowStockVariantProducts = productsData;
      state.lowStockVariantPageNo = state.lowStockVariantPageNo + 1;
      state.lowStockVariantProductsLoader = false;
    },
    [getAllLowStockVariantProducts.rejected]: (state) => {
      state.lowStockVariantProductsLoader = false;
    },

    //fetch Low Stock Child Variant Products
    [getLowStockChildVariantProducts.pending]: (state) => {
      state.lowStockChildVariantProductsLoader = true;
      state.lowStockChildVariantProducts = [];
      state.lowStockVariantProductHeader = [];
    },
    [getLowStockChildVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = prepareLowAndOOSProducts(productsData);

      if (filteredList?.length > 0) {
        const product = filteredList?.[0];

        let header = [];

        product?.variantInfo?.variants?.forEach((element) => {
          if (element?.code === "uom") {
            header = [
              ...header,
              { title: "Unit of Measure" },
              { title: "UOM Value" },
            ];
          } else header = [...header, { title: element?.code }];
        });

        state.lowStockChildVariantProductHeader = [
          ...header,
          ...LS_COLUMN_HEADER_CHILD_VARIANT,
        ];
      }

      state.lowStockChildVariantProducts = filteredList;
      state.lowStockChildVariantProductsLoader = false;
    },
    [getLowStockChildVariantProducts.rejected]: (state) => {
      state.lowStockChildVariantProductsLoader = false;
      state.lowStockChildVariantProducts = [];
      state.lowStockChildVariantProductHeader = [];
    },

    //Refresh Low Stock Update Products
    [refreshLowStockProducts.pending]: (state) => {
      state.lowStockProductsLoader = true;
      state.filterLoader = true;
    },
    [refreshLowStockProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = prepareLowAndOOSProducts(productsData);

      // if (productsData.length > 0) {
      state.lowStockProducts = [...filteredList];
      // }

      state.lowStockPageNo = 2;
      state.lowStockProductsLoader = false;
      state.filterLoader = false;
    },
    [refreshLowStockProducts.rejected]: (state) => {
      state.lowStockProductsLoader = false;
      state.filterLoader = false;
    },
    //Refresh Low Stock Update Products
    [refreshLowStockVariantProducts.pending]: (state) => {
      state.lowStockVariantProductsLoader = true;
      state.lowStockVariantProducts = [];
    },
    [refreshLowStockVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      state.lowStockVariantProducts = productsData;

      state.lowStockVariantPageNo = 2;
      state.lowStockVariantProductsLoader = false;
    },
    [refreshLowStockVariantProducts.rejected]: (state) => {
      state.lowStockVariantProductsLoader = false;
    },

    //fetch Out Of Stock Update Products
    [getAllOutOfStockProducts.pending]: (state) => {
      state.outOfStockProductsLoader = true;
    },
    [getAllOutOfStockProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = prepareLowAndOOSProducts(productsData);

      if (productsData.length > 0) {
        state.outOfStockProducts = [
          ...state.outOfStockProducts,
          ...filteredList,
        ];
      }

      state.outOfStockPageNo = state.outOfStockPageNo + 1;
      state.outOfStockProductsLoader = false;
    },
    [getAllOutOfStockProducts.rejected]: (state) => {
      state.outOfStockProductsLoader = false;
    },
    //fetch Out Of Stock Update Variant Products
    [getAllOutOfStockVariantProducts.pending]: (state) => {
      state.outOfStockVariantProductsLoader = true;
    },
    [getAllOutOfStockVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];
      state.outOfStockVariantProducts = productsData;

      state.outOfStockVariantPageNo = state.outOfStockVariantPageNo + 1;
      state.outOfStockVariantProductsLoader = false;
    },
    [getAllOutOfStockVariantProducts.rejected]: (state) => {
      state.outOfStockVariantProductsLoader = false;
    },

    //fetch Price Update Child Variant Products
    [getOutOfStockChildVariantProducts.pending]: (state) => {
      state.outOfStockChildVariantProductsLoader = true;
      state.outOfStockChildVariantProducts = [];
      state.outOfStockChildVariantProductHeader = [];
    },
    [getOutOfStockChildVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterPriceUpdateProducts(productsData);

      if (filteredList?.length > 0) {
        const product = filteredList?.[0];

        let header = [];

        product?.variantInfo?.variants?.forEach((element) => {
          if (element?.code === "uom") {
            header = [
              ...header,
              { title: "Unit of Measure" },
              { title: "UOM Value" },
            ];
          } else header = [...header, { title: element?.code }];
        });

        state.outOfStockChildVariantProductHeader = [
          ...header,
          ...OOS_COLUMN_HEADER_CHILD_VARIANT,
        ];
      }

      state.outOfStockChildVariantProducts = filteredList;
      state.outOfStockChildVariantProductsLoader = false;
    },
    [getOutOfStockChildVariantProducts.rejected]: (state) => {
      state.outOfStockChildVariantProductsLoader = false;
      state.outOfStockChildVariantProducts = [];
      state.outOfStockChildVariantProductHeader = [];
    },

    //Refresh Out Of Stock Update Products
    [refreshOutOfStockProducts.pending]: (state) => {
      state.outOfStockProductsLoader = true;
      state.filterLoader = true;
    },
    [refreshOutOfStockProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = prepareLowAndOOSProducts(productsData);

      if (productsData.length > 0) {
        state.outOfStockProducts = [...filteredList];
      }

      state.outOfStockPageNo = 2;
      state.outOfStockProductsLoader = false;
      state.filterLoader = false;
    },
    [refreshOutOfStockProducts.rejected]: (state) => {
      state.outOfStockProductsLoader = false;
      state.filterLoader = false;
    },
    //Refresh Out Of Stock Update Products
    [refreshOutOfStockVariantProducts.pending]: (state) => {
      state.outOfStockVariantProductsLoader = true;
      state.outOfStockVariantProducts = [];
    },
    [refreshOutOfStockVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      state.outOfStockVariantProducts = productsData;

      state.outOfStockVariantPageNo = 2;
      state.outOfStockVariantProductsLoader = false;
    },
    [refreshOutOfStockVariantProducts.rejected]: (state) => {
      state.outOfStockVariantProductsLoader = false;
    },

    //fetch Price Update Products
    [getPriceUpdateProducts.pending]: (state) => {
      state.priceUpdateProductsLoader = true;
    },
    [getPriceUpdateProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterPriceUpdateProducts(productsData);

      if (productsData.length > 0) {
        state.priceUpdateProducts = [
          ...state.priceUpdateProducts,
          ...filteredList,
        ];
      }

      state.priceUpdatePageNo = state.priceUpdatePageNo + 1;
      state.priceUpdateProductsLoader = false;
    },
    [getPriceUpdateProducts.rejected]: (state) => {
      state.priceUpdateProductsLoader = false;
    },

    //fetch Price Update Variant Products
    [getPriceUpdateVariantProducts.pending]: (state) => {
      state.priceUpdateVariantProductsLoader = true;
    },
    [getPriceUpdateVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      state.priceUpdateVariantProducts = productsData;

      state.priceUpdateVariantPageNo = state.priceUpdateVariantPageNo + 1;
      state.priceUpdateVariantProductsLoader = false;
    },
    [getPriceUpdateVariantProducts.rejected]: (state) => {
      state.priceUpdateVariantProductsLoader = false;
    },

    //fetch Price Update Child Variant Products
    [getPriceUpdateChildVariantProducts.pending]: (state) => {
      state.priceUpdateChildVariantProductsLoader = true;
      state.priceUpdateChildVariantProducts = [];
      state.priceChildVariantProductHeader = [];
    },
    [getPriceUpdateChildVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterPriceUpdateProducts(productsData);

      if (filteredList?.length > 0) {
        const product = filteredList?.[0];

        let header = [];

        product?.variantInfo?.variants?.forEach((element) => {
          if (element?.code === "uom") {
            header = [
              ...header,
              { title: "Unit of Measure" },
              { title: "UOM Value" },
            ];
          } else header = [...header, { title: element?.code }];
        });

        state.priceUpdateChildVariantProductHeader = [
          ...header,
          ...PU_COLUMN_HEADER_CHILD_VARIANT,
        ];
      }

      state.priceUpdateChildVariantProducts = filteredList;
      state.priceUpdateChildVariantProductsLoader = false;
    },
    [getPriceUpdateChildVariantProducts.rejected]: (state) => {
      state.priceUpdateChildVariantProductsLoader = false;
      state.priceUpdateChildVariantProducts = [];
      state.priceUpdateChildVariantProductHeader = [];
    },

    //Refresh Price Update Products
    [refreshPriceUpdateProducts.pending]: (state) => {
      state.priceUpdateProductsLoader = true;
      state.filterLoader = true;
    },
    [refreshPriceUpdateProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterPriceUpdateProducts(productsData);

      if (productsData.length > 0) {
        state.priceUpdateProducts = [...filteredList];
      }

      state.priceUpdatePageNo = 2;
      state.priceUpdateProductsLoader = false;
      state.filterLoader = false;
    },
    [refreshPriceUpdateProducts.rejected]: (state) => {
      state.priceUpdateProductsLoader = false;
      state.filterLoader = false;
    },

    //Refresh All Stock Update Variant Products
    [refreshPriceUpdateChildProducts.pending]: (state) => {
      state.priceUpdateVariantProductsLoader = true;
    },
    [refreshPriceUpdateChildProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      state.priceUpdateVariantProducts = productsData;
      state.priceUpdateVariantPageNo = 2;
      state.priceUpdateVariantProductsLoader = false;
    },
    [refreshPriceUpdateChildProducts.rejected]: (state) => {
      state.priceUpdateVariantProductsLoader = false;
    },

    //fetch All Stock Update Products
    [getAllStockUpdateProducts.pending]: (state) => {
      state.allStockUpdateProductsLoader = true;
    },
    [getAllStockUpdateProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterPriceUpdateProducts(productsData);

      console.log("productsDataproductsData", productsData, filteredList);

      if (productsData.length > 0) {
        state.allStockUpdateProducts = [
          ...state.allStockUpdateProducts,
          ...filteredList,
        ];
      }
      state.allStockUpdatePageNo = state.allStockUpdatePageNo + 1;
      state.allStockUpdateProductsLoader = false;
    },
    [getAllStockUpdateProducts.rejected]: (state) => {
      state.allStockUpdateProductsLoader = false;
    },
    //fetch All Stock Update Variant Products
    [getAllStockUpdateVariantProducts.pending]: (state) => {
      state.allStockUpdateVariantProductsLoader = true;
    },
    [getAllStockUpdateVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];
      state.allStockUpdateVariantProducts = productsData;
      state.allStockUpdateVariantPageNo = state.allStockUpdateVariantPageNo + 1;
      state.allStockUpdateVariantProductsLoader = false;
    },
    [getAllStockUpdateVariantProducts.rejected]: (state) => {
      state.allStockUpdateVariantProductsLoader = false;
    },

    //fetch All Stock Update Child Variant Products
    [getAllStockUpdateChildVariantProducts.pending]: (state) => {
      state.allStockUpdateChildVariantProductsLoader = true;
      state.allStockUpdateChildVariantProducts = [];
      state.allStockChildVariantProductHeader = [];
      state.allStockChildVariantProductMobileHeader = [];
    },
    [getAllStockUpdateChildVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterPriceUpdateProducts(productsData);

      if (filteredList?.length > 0) {
        const product = filteredList?.[0];

        let header = [];

        product?.variantInfo?.variants?.forEach((element) => {
          if (element?.code === "uom") {
            header = [
              ...header,
              { title: "Unit of Measure" },
              { title: "UOM Value" },
            ];
          } else header = [...header, { title: element?.code }];
        });

        state.allStockChildVariantProductHeader = [
          ...header,
          ...ALL_STOCK_COLUMN_HEADER_CHILD_VARIANT,
        ];

        state.allStockChildVariantProductMobileHeader = [
          ...header,
          {
            id: 33,
            title: "",
          },
        ];
      }

      state.allStockUpdateChildVariantProducts = filteredList;
      state.allStockUpdateChildVariantProductsLoader = false;
    },
    [getAllStockUpdateChildVariantProducts.rejected]: (state) => {
      state.allStockUpdateChildVariantProductsLoader = false;
      state.allStockUpdateChildVariantProducts = [];
      state.allStockChildVariantProductHeader = [];
      state.allStockChildVariantProductMobileHeader = [];
    },

    //Refresh All Stock Update Products
    [refreshAllStockUpdateProducts.pending]: (state) => {
      state.allStockUpdateProductsLoader = true;
      state.filterCount = 0;
      state.filterLoader = true;
    },
    [refreshAllStockUpdateProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterPriceUpdateProducts(productsData);

      if (productsData.length > 0) {
        state.allStockUpdateProducts = [...filteredList];
      }
      state.allStockUpdatePageNo = 2;
      state.allStockUpdateProductsLoader = false;
      state.filterLoader = false;
    },
    [refreshAllStockUpdateProducts.rejected]: (state) => {
      state.allStockUpdateProductsLoader = false;
      state.filterLoader = false;
    },

    //Refresh All Stock Update Variant Products
    [refreshAllStockUpdateVariantProducts.pending]: (state) => {
      state.allStockUpdateVariantProductsLoader = true;
    },
    [refreshAllStockUpdateVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];
      state.allStockUpdateVariantProducts = productsData;
      state.allStockUpdateVariantPageNo = 2;
      state.allStockUpdateVariantProductsLoader = false;
    },
    [refreshAllStockUpdateVariantProducts.rejected]: (state) => {
      state.allStockUpdateVariantProductsLoader = false;
    },

    //fetch Not Selling Update Products
    [getNotSellingUpdateProducts.pending]: (state) => {
      state.notSellingUpdateProductsLoader = true;
    },
    [getNotSellingUpdateProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterNotSellingProducts(productsData);

      // if (productsData.length > 0) {
      state.notSellingUpdateProducts = [
        ...state.notSellingUpdateProducts,
        ...filteredList,
      ];
      // }

      state.notSellingUpdatePageNo = state.notSellingUpdatePageNo + 1;
      state.notSellingUpdateProductsLoader = false;
    },
    [getNotSellingUpdateProducts.rejected]: (state) => {
      state.notSellingUpdateProductsLoader = false;
    },

    //fetch Not Selling Variant Products
    [getNotSellingVariantProducts.pending]: (state) => {
      state.notSellingVariantProductsLoader = true;
    },
    [getNotSellingVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      state.notSellingVariantProducts = productsData;
      state.notSellingVariantPageNo = state.notSellingVariantPageNo + 1;
      state.notSellingVariantProductsLoader = false;
    },
    [getNotSellingVariantProducts.rejected]: (state) => {
      state.notSellingVariantProductsLoader = false;
    },

    //fetch Not Selling Child Variant Products
    [getNotSellingChildVariantProducts.pending]: (state) => {
      state.notSellingChildVariantProductsLoader = true;
      state.notSellingChildVariantProducts = [];
      state.notSellingChildVariantProductHeader = [];
      state.notSellingChildVariantProductMobileHeader = [];
    },
    [getNotSellingChildVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterNotSellingProducts(productsData);

      if (filteredList?.length > 0) {
        const product = filteredList?.[0];

        let header = [];

        product?.variantInfo?.variants?.forEach((element) => {
          if (element?.code === "uom") {
            header = [
              ...header,
              { title: "Unit of Measure" },
              { title: "UOM Value" },
            ];
          } else header = [...header, { title: element?.code }];
        });

        state.notSellingChildVariantProductHeader = [
          ...header,
          ...ALL_STOCK_COLUMN_HEADER_CHILD_VARIANT,
        ];

        state.notSellingChildVariantProductMobileHeader = [
          ...header,
          {
            id: 33,
            title: "",
          },
        ];
      }

      state.notSellingChildVariantProducts = filteredList;
      state.notSellingChildVariantProductsLoader = false;
    },
    [getNotSellingChildVariantProducts.rejected]: (state) => {
      state.notSellingChildVariantProductsLoader = false;
      state.notSellingChildVariantProducts = [];
      state.notSellingChildVariantProductHeader = [];
      state.notSellingChildVariantProductMobileHeader = [];
    },

    //Refresh Not Selling Update Products
    [refreshNotSellingUpdateProducts.pending]: (state) => {
      state.notSellingUpdateProductsLoader = true;
      state.filterLoader = true;
    },
    [refreshNotSellingUpdateProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];

      const filteredList = filterNotSellingProducts(productsData);

      // if (productsData.length > 0) {
      state.notSellingUpdateProducts = [...filteredList];
      // }

      state.notSellingUpdatePageNo = 2;
      state.notSellingUpdateProductsLoader = false;
      state.filterLoader = false;
    },
    [refreshNotSellingUpdateProducts.rejected]: (state) => {
      state.notSellingUpdateProductsLoader = false;
      state.filterLoader = false;
    },

    //Refresh Not selling Variant Products
    [refreshNotSellingVariantProducts.pending]: (state) => {
      state.notSellingVariantProductsLoader = true;
    },
    [refreshNotSellingVariantProducts.fulfilled]: (state, { payload }) => {
      const productsData = payload?.details || [];
      state.notSellingVariantProducts = [...productsData];
      console.log("productsDataproductsData_3", productsData);
      state.notSellingVariantPageNo = 2;
      state.notSellingVariantProductsLoader = false;
    },
    [refreshNotSellingVariantProducts.rejected]: (state) => {
      state.notSellingVariantProductsLoader = false;
    },

    //Get Inventory summary Count
    [getInventorySummaryCounts.pending]: (state) => {
      state.summaryLoader = true;
    },
    [getInventorySummaryCounts.fulfilled]: (state, { payload }) => {
      state.inventorySummary = payload?.variantAllCount;
      state.summaryLoader = false;
    },
    [getInventorySummaryCounts.rejected]: (state) => {
      state.summaryLoader = false;
    },

    //Search Inventory Products
    [searchInventoryProducts.pending]: (state) => {
      state.searchLoader = true;
    },
    [searchInventoryProducts.fulfilled]: (state, { payload }) => {
      const { result, status, type } = payload;

      console.log("searchInventoryProducts", result);

      if (status === "all_stock") {
        if (type === "withoutvariant") {
          const filteredList = filterPriceUpdateProducts(result);
          state.allStockUpdateProducts = filteredList || [];
          state.allStockUpdatePageNo = 2;
        } else {
          state.allStockUpdateVariantProducts = result || [];
        }
      } else if (status === "price_update") {
        if (type === "withoutvariant") {
          const filteredList = filterPriceUpdateProducts(result);
          state.priceUpdateProducts = filteredList || [];
          state.priceUpdatePageNo = 2;
        } else {
          state.priceUpdateVariantProducts = result || [];
        }
      } else if (status === "low_stock") {
        const filteredList = prepareLowAndOOSProducts(result);
        if (type === "withoutvariant") {
          state.lowStockProducts = filteredList || [];
          state.lowStockPageNo = 2;
        } else {
          state.lowStockVariantProducts = result || [];
        }
      } else if (status === "out_of_stock") {
        const filteredList = prepareLowAndOOSProducts(result);
        if (type === "withoutvariant") {
          state.outOfStockProducts = filteredList || [];
          state.outOfStockPageNo = 2;
        } else {
          state.outOfStockVariantProducts = result || [];
        }
      } else if (status === "not_selling") {
        if (type === "withoutvariant") {
          const filteredList = filterNotSellingProducts(result);
          state.notSellingUpdateProducts = filteredList || [];
          state.notSellingUpdatePageNo = 2;
        } else {
          state.notSellingVariantProducts = result || [];
        }
      } else {
      }

      state.searchLoader = false;
    },
    [searchInventoryProducts.rejected]: (state) => {
      state.searchLoader = false;
    },

    //Get Category Dropdown Data
    [getCategoryDropdownListData.pending]: (state) => {
      state.categoryLoader = true;
    },
    [getCategoryDropdownListData.fulfilled]: (state, { payload }) => {
      const { ondcCategoryData } = payload;
      const ondcCategory = ondcCategoryData?.map(
        ({ _id, productSubCategory }) => ({
          ondcCode: _id?.ondcCode,
          ondcValue: _id?.ondcValue,
          productSubCategory,
        })
      );
      state.ondcDropdownData = ondcCategory || [];
    },
    [getCategoryDropdownListData.rejected]: (state) => {
      state.categoryLoader = false;
    },

    //ONDC Filter Inventory Products
    [filterInventoryOndcProducts.pending]: (state, { meta }) => {
      const pageNo = meta?.arg?.pageNo || 1;

      state.allStockUpdateProductsLoader = true;
      state.priceUpdateProductsLoader = true;
      state.lowStockProductsLoader = true;
      state.outOfStockProductsLoader = true;
      state.notSellingUpdateProductsLoader = true;
      state.filterLoader = pageNo === 1;
      // state.filterCount = pageNo === 1 && 0;
    },
    [filterInventoryOndcProducts.fulfilled]: (state, { payload }) => {
      const { result, status, pageNo, type, filterCount } = payload;

      console.log("Filter", result, status, pageNo, type, filterCount);

      if (status === "all_stock") {
        if (type === "withoutvariant") {
          const filteredList = filterPriceUpdateProducts(result);
          if (result.length > 0)
            state.allStockUpdateProducts =
              pageNo == 1
                ? [...filteredList]
                : [...state.allStockUpdateProducts, ...filteredList];

          state.allStockUpdatePageNo =
            pageNo == 1 ? 2 : state.allStockUpdatePageNo + 1;
        } else {
          state.allStockUpdateVariantProducts = [...result];
        }
      } else if (status === "price_update") {
        if (type === "withoutvariant") {
          const filteredList = filterPriceUpdateProducts(result);
          if (result.length > 0)
            state.priceUpdateProducts =
              pageNo == 1
                ? [...filteredList]
                : [...state.priceUpdateProducts, ...filteredList];
          state.priceUpdatePageNo =
            pageNo == 1 ? 2 : state.priceUpdatePageNo + 1;
        } else state.priceUpdateVariantProducts = result || [];
      } else if (status === "low_stock") {
        const filteredList = prepareLowAndOOSProducts(result);

        if (type === "withoutvariant") {
          state.lowStockProducts =
            pageNo == 1
              ? [...filteredList]
              : [...state.lowStockProducts, ...filteredList];

          state.lowStockPageNo = pageNo == 1 ? 2 : state.lowStockPageNo + 1;
        } else state.lowStockVariantProducts = result || [];
      } else if (status === "out_of_stock") {
        const filteredList = prepareLowAndOOSProducts(result);

        if (type === "withoutvariant") {
          state.outOfStockProducts =
            pageNo == 1
              ? [...filteredList]
              : [...state.outOfStockProducts, ...filteredList];

          state.outOfStockPageNo = pageNo == 1 ? 2 : state.outOfStockPageNo + 1;
        } else state.outOfStockVariantProducts = result || [];
      } else if (status === "not_selling") {
        if (type === "withoutvariant") {
          const filteredList = filterNotSellingProducts(result);
          if (result.length > 0)
            state.notSellingUpdateProducts =
              pageNo == 1
                ? [...filteredList]
                : [...state.notSellingUpdateProducts, ...filteredList];

          state.notSellingUpdatePageNo =
            pageNo == 1 ? 2 : state.notSellingUpdatePageNo + 1;
        } else state.notSellingVariantProducts = result || [];
      } else {
      }

      state.allStockUpdateProductsLoader = false;
      state.priceUpdateProductsLoader = false;
      state.lowStockProductsLoader = false;
      state.outOfStockProductsLoader = false;
      state.notSellingUpdateProductsLoader = false;
      state.filterCount = filterCount;
      state.filterLoader = false;
    },
    [filterInventoryOndcProducts.rejected]: (state) => {
      state.allStockUpdateProductsLoader = false;
      state.priceUpdateProductsLoader = false;
      state.lowStockProductsLoader = false;
      state.outOfStockProductsLoader = false;
      state.notSellingUpdateProductsLoader = false;
      state.filterLoader = false;
    },

    //Get Category Dropdown Data
    [getVariantSingleCount.pending]: (state) => {
      state.variantSingleInventoryCountLoader = true;
    },
    [getVariantSingleCount.fulfilled]: (state, { payload }) => {
      state.variantSingleInventoryCount = payload?.variantAllCount || null;
      state.variantSingleInventoryCountLoader = false;
    },
    [getVariantSingleCount.rejected]: (state) => {
      state.variantSingleInventoryCountLoader = false;
    },
  },
});

export const {
  clearInventoryInfo,
  clearAllInventoryInfo,

  handlePriceUpdateChange,
  handleQuickPriceUpdate,
  updatePriceInfoList,
  updatePriceInfoVariantList,

  handleAllStockUpdateChange,
  handleQuickAllStockUpdate,
  updateAllStockInfoList,
  updateAllStockInfoVariantList,

  handleAllStockChildUpdateChange,
  handlePriceUpdateChildProductChange,

  handleNotSellingUpdateChange,
  handleQuickNotSellingUpdate,
  updateNotSellingInfoList,

  handleLowStockUpdateChange,
  handleLowStockVariantUpdateChange,
  updateLowStockInfoList,
  updateLowStockInfoVariantList,

  handleOutOfStockUpdateChange,
  updateOutOfStockInfoList,
  handleOutOfStockVariantUpdateChange,
  updateOutOfStockVariantInfoList,

  selectAllInventoryProducts,

  updateInventorySummary,
  handleNotSellingChildUpdateChange,
  updateNotSellingInfoVariantList,
  clearFilterCount,
} = businessInventory.actions;

export const businessInventoryReducer = businessInventory.reducer;
